// extracted by mini-css-extract-plugin
export default {"full-page-spinner":"FullPageSpinner_full-page-spinner__QMICN"};